import React, { useReducer, useEffect, useContext, useRef, useState } from "react";
import activoContext from "./activoContex";
import { getAllActivos, getByCodActivo, addActivo, updateActivo, deleteActivo, toggleDeBajaActivo, addFiles, deleteFile, getFiles, getDocFiles, getFServFiles, calcMantenimientos, getProcsProgramados, getDocs, getLastLectByUnidadAndActivo, addNewLectura, updateFServ, updateFecVencimientoDoc, getLecturasByActivoId, addProcProgramado, updateProcProgramado, calcMantenimientoByActivo, modificarUserworkingActivo, requestUpdateUserWorking, updateUbicacionActivo, addProcDirecto, deleteFilesByCampoAndActivo, getActivosAllowed, checkIfActHasODTForBreaking, getInfoActDashboard, getInfoActReporte, updatePositioning, getActivosAsOptions, getControlServicios, getConsumoHorasMensual, setCambioHorometro } from "../../api/activo";
import activoReducer from "./activoReducer";

//Types
import { 
    ACTUALIZAR_DOCSXACTIVO,
    ACTUALIZAR_LIST_ACTIVO,
    ACTUALIZAR_PROCS_PROGRAMADOS,
    INICIALIZAR_FILTROS,
    MODIFICAR_FILTROS,
    MODIFICAR_FILTROS_ESTADOS,
    MODIFICAR_FILTROS_RANGO,
    SET_FILTERS,
    SET_INFO_DASHBOARD_ACTIVOS
  } from "./activoActions";
import { SocketContext } from "../socket/socket";
import authContext from "../authentication/authContex";
import moment from "moment";
import { ACTIVOSTATES, ALERTSProcedimientosProgramados, CHECKLISTStates, CRITICIDAD, ORIGENES, STATESProcsProgramados, TIPPROCS } from "../../utils/states";
import { deepEqual, filtrosToString } from "../../utils/funciones";
import { getUsersInGroupV } from "../../api/user";
import { unidadesMedidasOpciones } from "../../utils/estructuras";
import Swal from "sweetalert2";


const ActivoState = props =>{

    const server = useContext(SocketContext);
    
    const initialState = {
        activoList: null,
        procsProgramadosList: null,
        docsXactivoList: null,
        filtros:{
            areas:[],
            nivel2s:[],
            nivel3s:[],
            nivel4s:[],
            nivel5s:[],
            state: [...ACTIVOSTATES],
            criticidad: [...CRITICIDAD],
            uniMeds: [...unidadesMedidasOpciones.map(u => u.value)]
        },
        filtrosProcsProgramadosRango:{
            fecAlt: {
                desde: new Date(moment(new Date).subtract(124, 'days')),
                // desde: new Date(moment(new Date).subtract(25, 'years')),
                hasta: new Date(moment(new Date())),
            },
            fecVencimientoDesde: new Date(moment(new Date).add(-365, 'days')),
            fecVencimientoHasta: new Date(moment(new Date).add(365, 'days')),
            fecCompletadoHasta: new Date(moment(new Date).add(365, 'days')),
            deliveryDate: new Date(moment(new Date).add(30, 'days'))
        },
        filtrosProcsProgramadosEstado: {
            statesProcedimientos: STATESProcsProgramados,
            tipoAlerta: ALERTSProcedimientosProgramados,
            tipoProcedimientos: TIPPROCS,
            statesChecklist: CHECKLISTStates,
            tipoActivos: [],
            priority: [0, 1, 2],
            userName: [],
            origenes: ORIGENES,
            activos: []
        },
        infoActivosDashboard: null,
        cargandoActivos:true,
        cargandoProcsProgramados:true,
        filtrosProcsInicializados: false,
    };
    
    const [state, dispatch] = useReducer(activoReducer, initialState);
    const activoListRef = useRef(state.activoList);

    const aContext = useContext(authContext);
    const {usuario, verificarTenant} = aContext;

    const userRef = useRef(usuario);

    //Recupera el WorkSpace definido al seleccionar que tipo de procedimientos asociados al activo visualizar.
    const [wSpaceFromActivos, setWSpaceFromActivos] = useState(localStorage.getItem('workspaceSelected') || null);
        
    //Recupera el ORIGEN definido al seleccionar que tipo de procedimientos asociados al activo visualizar.
    const [origenFromActivos, setOrigenFromActivos] = useState(localStorage.getItem('origen') || null);

    const actualizaractivoList = async () => {
        try{
            let resp;
            let activosAllowed = userRef.current.activosAllowed;

            if(activosAllowed.length == 0) resp = await getAllActivos();
            else resp = await getActivosAllowed(activosAllowed);

            let activo = resp.data.data;
            activo = activo.map((a,i) => ({...a, position: a.position ?? i + 1})); //Si no tiene position seteado, utiliza el index del arreglo.

            activoListRef.current = activo;
            dispatch({
                type: ACTUALIZAR_LIST_ACTIVO,
                payload: activo
            });
            return activo;
        }catch(err){
            console.log(err)
            return err;
        }
    };

    const obtenerActivosAsOptions = async (filter) => {
        try {
            const resp = await getActivosAsOptions(filter);
            return resp.data.data;
        } catch (err) {
            console.log(err);
            return [];
        }
    };

    const getActivoByCodActivo = async (codActivo) => {
        try {
            const resp = await  getByCodActivo(codActivo);
            const activo = resp.data.data;
            return activo;
        } catch(err){
            console.log(err)
        }
    }

    //S3
    const getFilesActivo = async (codActivo, campo) => {
        try {
            const resp = await  getFiles(codActivo, campo);
            //Dato contendra los archivos recuperados; Campo especifica si pertenece a General, QR o Imagen Principal del Activo.
            const files = { dato: { files: resp.data?.files?.slice() ?? undefined, campo: campo } };
            return files;
        } catch(err){
            console.log(err)
        }
    }

    const getDocFilesActivo = async (codActivo) => {
        try {
            const resp = await getDocFiles(codActivo);
            return resp.data.files;
        } catch(err) {
            console.log(err);
            return [];
        }
    }

    const getFServFilesActivo = async (codActivo) => {
        try {
            const resp = await getFServFiles(codActivo);
            return resp.data.files;
        } catch(err) {
            console.log(err);
            return [];
        }
    }

    const agregarActivo = async (formDato,itemsList,files) => {
        try{
            // Luego, puedes enviar estos datos al backend usando una función llamada addactivoType
            const resp = await addActivo(formDato, itemsList);
            const activo = resp.data.data;
            if(files?.length > 0) {
                //await agregarArchivos(resp.data.data, files);
                 files?.map(async (f) => {
                     if (f.campo === 'general')
                         await agregarArchivos(resp.data.data, 'general', [f]);
                     if (f.campo === 'imagen')
                        await agregarArchivos(resp.data.data, 'imagen', [f]);
                 });
                }
            actualizaractivoList(usuario.activosAllowed)
            return activo;
        }catch(err){
            console.log(err);
            return err;
        }
    };
    
    //-------------- Modificar Activos --------------------------------------------------------------------
    const modificarActivo = async (formDato, itemsList, selectedFiles, docFiles = [], fServFiles = [] ) => {
        //Trackeamos los uploads de dispo para limpiar S3 si algo falla antes del commit (PUT).
        //Una vez que el PUT exitoso persiste archivo en DB, los uploads estan "committed" y no se limpian.
        const uploadedDispoKeys = [];
        let uploadsCommitted = false;
        try {
            //Disponibilidad: subir primero los ADD para obtener las keys y armar el archivo
            //final por rowKey. El backend valida fecMod en el upload antes de tocar S3
            //y borra los archivos viejos al detectar cambio de archivo en una fila.
            const fServFilesToAdd = fServFiles.filter(f => f.accion === 'ADD');
            const newKeysByRowKey = {};
            for (const ff of fServFilesToAdd) {
                const uploadResp = await agregarArchivosConKey(formDato, `dispo-${ff.rowKey}`, [{ dato: ff.file }]);
                const key = uploadResp?.keys?.[0];
                if(key){
                    newKeysByRowKey[ff.rowKey] = key;
                    uploadedDispoKeys.push(key);
                }
            }

            if(Array.isArray(formDato.logsFServ)){
                formDato.logsFServ = formDato.logsFServ.map(l => {
                    const entry = fServFiles.find(f => f.rowKey === l.rowKey && f.accion !== 'DELETE');
                    let archivo;
                    if(newKeysByRowKey[l.rowKey] !== undefined) archivo = newKeysByRowKey[l.rowKey];          //ADD nuevo
                    else if(entry && !entry.accion) archivo = entry.existingName || entry.name || null;     //Existente sin tocar
                    else archivo = null;                                                                     //Sin archivo (o DELETE puro)
                    return { ...l, archivo };
                });
            }

            const resp = await updateActivo(formDato, itemsList);
            uploadsCommitted = true;

            const activo = resp.data.data;

            if (selectedFiles.length !== 0) {
                let filesGeneralesToAdd = selectedFiles.filter(f => f.campo == 'general' && f.accion == 'ADD');
                let filesGeneralesToDelete = selectedFiles.filter(f => f.accion == 'DELETE');
                let imageActivoFile = selectedFiles.filter(f => f.campo == 'imagen');

                try {
                    if(imageActivoFile.length > 0){
                        await deleteFilesByCampoAndActivo(resp.data.data.codActivo,'imagen');
                        await agregarArchivos(resp.data.data, 'imagen', imageActivoFile);
                    }

                    await agregarArchivos(resp.data.data, 'general', filesGeneralesToAdd);

                    for (const file of filesGeneralesToDelete) {
                        await deleteFile(file.name);
                    }
                } catch (error) {
                    console.log("error en modificarActivo al agregar/eliminar archivos");
                    console.log(error);
                }
            }

            if (docFiles.length > 0) {
                try {
                    let docFilesToAdd = docFiles.filter(f => f.accion === 'ADD');
                    let docFilesToDelete = docFiles.filter(f => f.accion === 'DELETE');

                    for (const df of docFilesToDelete) {
                        await deleteFilesByCampoAndActivo(resp.data.data.codActivo, `doc-${df.codDocumento}`);
                    }

                    for (const df of docFilesToAdd) {
                        await agregarArchivos(resp.data.data, `doc-${df.codDocumento}`, [{ dato: df.file }]);
                    }
                } catch (error) {
                    console.log("error en modificarActivo al agregar/eliminar archivos de documentos");
                    console.log(error);
                }
            }

            //Disponibilidad: archivos ya se procesaron antes de updateActivo.
            //El backend gestiona todos los deletes (fila borrada -> prune; archivo cambiado -> compara old vs new).

            return activo;
        } catch (err) {
            //Si el error ocurrio antes del PUT exitoso, limpiar los uploads que hicimos
            //para no dejar huerfanos en S3 (el PUT no llego a persistir sus keys en DB).
            if(!uploadsCommitted && uploadedDispoKeys.length > 0){
                for(const key of uploadedDispoKeys){
                    try { await deleteFile(key); } catch (e) { console.log("Cleanup fallo para", key, e); }
                }
            }
            return err;
        }
    }

    const modificarUserTrabajandoActivo = async (activoId,usuarioWorking) =>{
        try {
            const resp = await modificarUserworkingActivo(activoId,usuarioWorking);
            return resp;
        } catch (error) {
            console.log("error en modificarUserTrabajandoActivo en activoState 148");
            console.log(error);
            
        }
    }
        
    //------------------------------------------------------------------------------------------------

    const eliminarActivo = async (id, updates, files, from = '') => {
        try{
            const resp = await deleteActivo(id, updates);
            const activo = resp;

            // Aplanar el array de archivos en un solo array de objetos de archivos
            if(Array.isArray(files) && files.length > 0){
                const allFiles = files.flatMap(obj => obj.dato.files);
                const fileNames = allFiles.map(file => file.name);

                // Ahora puedes eliminar los archivos
                for (const fileName of fileNames) {
                    await deleteFile(fileName);
                }
            }

            const swalConfig = activo?.data?.success
                ? {title:'Borrado!', html: `${activo?.data?.data?.name} fue borrado correctamente.`, icon:'success'}
                : {title:'Ops!', html: `${activo?.data?.msg}.`, icon:'error'};

            if(from === 'TreeActivo') return swalConfig;

            Swal.fire(swalConfig);
            return activo;
        }catch(err){
            console.log(err)
            const errorConfig = {title:'Ops!', text: err?.response?.data?.message, icon: 'error'};
            if(from === 'TreeActivo') return errorConfig;
            Swal.fire(errorConfig);
        }
    }

    const toggleDeBajaActivoCtx = async (id, from = '') => {
        try {
            const resp = await toggleDeBajaActivo(id);
            const data = resp?.data;

            const swalConfig = data?.success
                ? { title: data?.data?.deBaja ? 'Deshabilitado!' : 'Habilitado!', html: data?.msg, icon: 'success' }
                : { title: 'Ops!', html: data?.message || 'No se pudo actualizar el estado del activo.', icon: 'error' };

            if (from === 'TreeActivo') return swalConfig;

            Swal.fire(swalConfig);
            return data;
        } catch (err) {
            console.log(err);
            const errorConfig = { title: 'Ops!', text: err?.response?.data?.message || 'Error al actualizar el activo', icon: 'error' };
            if (from === 'TreeActivo') return errorConfig;
            Swal.fire(errorConfig);
        }
    }

    /*
    Mantenimientos Programados Functions
    Al ser parte de Activos no se decide crear un contexto aparte.
    */
   const getMantenimientosProgramados = async() => {
       try {
           let res = await getProcsProgramados();
           dispatch({
               type: ACTUALIZAR_PROCS_PROGRAMADOS,
               payload: res.data.procs
           });
           return res.data.procs;
       } catch (error) {
           console.log(error);
           return error.message;
       }
   }
   
   const calcularMantenimientos = async() => {
       try {
           let res = await calcMantenimientos();
           await new Promise((resolve) => setTimeout(resolve, 2000));
           await getMantenimientosProgramados();
           return res.data.msg;
       } catch (error) {
           return error.message;
       }
   }
    
    const calcularMantenimientoByActivo = async(activo) => {
        try {
            let res = await calcMantenimientoByActivo(activo);
            return true;
        } catch (error) {
            console.log("error en calcularMantenimientoByActivo de activoState");
            console.log(error);
            return error.message;
        }
    }

    const getDocsXActivo = async() => {
        try {
            let res = await getDocs();
            dispatch({
                type: ACTUALIZAR_DOCSXACTIVO,
                payload: res.data.docs
            })
            return res.data.docs;
        } catch (error) {
            console.log(error);
            return error.message;
            
        }
    }

    const updateUserWorking = async(activoID,userWorking) => {
        try {
            let res = await requestUpdateUserWorking(activoID,userWorking);
            return res.data;
        } catch (error) {
            console.log(error);
            return error;
        }
    }
    const getLastLecturaByUnidadAndActivo = async(activoID,uniMed) => {
        try {
            let res = await getLastLectByUnidadAndActivo(activoID,uniMed);
            return res.data;
        } catch (error) {
            console.log(error);
            return error;
        }
    }

    const addLectura = async(newLect) => {
        try {
            const res = await addNewLectura(newLect);
            return res.data;
        } catch (error) {
            return error;
        }
    }

    const actualizarFServ = async(activoID,fServActual,logToUpload) => {
        try {
            const res = await updateFServ(activoID,fServActual,logToUpload);
            return res.data;
        } catch (error) {
            console.log(error);
            return error.message;
        }
    }

    const checkIfActivoHasODTForBreaking = async(activoID) => {
        try {
            const res = await checkIfActHasODTForBreaking(activoID);
            return res.data?.enableActivo;
        } catch (error) {
            console.log("error en checkIfActivoHasODTForBreaking de activoState");
            console.log(error);
            return false;
        }
    }

    const addProcedimientoProgramado = async(procProgramado) => {
        try {
            const res = await addProcProgramado(procProgramado);
            if(res.data.procCreated != undefined && res.data.created == true) return res.data.procCreated            
            else return false;
        } catch (error) {
            console.log(error);
            return error.message;
        } 
    }
    
    const addProcedimientoDirecto = async(procProgramado,activo) => {
        try {
            const res = await addProcDirecto(procProgramado,activo);
            if(res.data.procCreated != undefined && res.data.created == true) return res.data.procCreated            
            else return false;
        } catch (error) {
            console.log(error);
            return error.message;
        } 
    }

    const actualizarProcProgramado = async(newProcProgramado) => {
        try {
            const res = await updateProcProgramado(newProcProgramado);
            return res;
        } catch (error) {
            console.log(error);
            return error.message;
        }
    }

    const actualizarFecVencimientoDoc = async(activoID,documentoID,newFecha) =>{
        try {
            const res = await updateFecVencimientoDoc(activoID,documentoID,newFecha);
            return res.data;
        } catch (error) {
            console.log(error);
            return error.message
        }
    }

    const getLectsByActivoId = async(activoId,uniMed) => {
        try {
            const res = await getLecturasByActivoId(activoId,uniMed);
            return res.data;
        } catch (error) {
            console.log(error);
            return error.message;
        }
    }

    const actualizarUbicacionActivo = async(activoID,codActivo,ubicacionUpdates,userID,userName) =>{
        try {
            const res = updateUbicacionActivo(activoID,codActivo,ubicacionUpdates,userID,userName);
            return res;
        } catch (error) {
            console.log(error);
            return error.message;
        }
    }

    const getInfoActivosReporte = async() => {
        try {
            const resp = await getInfoActReporte();
            return resp.data;
        } catch (error) {
            console.log("error en getInfoActivosDashboard");
            console.log(error);

        }
    }
    const getControlServiciosReporte = async(activos = []) => {
        try {
            const resp = await getControlServicios(activos);
            return resp.data;
        } catch (error) {
            console.log("error en getControlServiciosReporte");
            console.log(error);
        }
    }
    const getConsumoHorasMensualReporte = async(dateFrom, dateTo) => {
        try {
            const resp = await getConsumoHorasMensual(dateFrom, dateTo);
            return resp.data;
        } catch (error) {
            console.log("error en getConsumoHorasMensualReporte");
            console.log(error);
        }
    }
    const guardarCambioHorometro = async(activoID, periodo, cambioHorometro) => {
        try {
            const resp = await setCambioHorometro(activoID, periodo, cambioHorometro);
            return resp.data;
        } catch (error) {
            console.log("error en guardarCambioHorometro");
            console.log(error);
        }
    }
    const getInfoActivosDashboard = async(filtrosEstado = null) => {
        try {
            const resp = await getInfoActDashboard(filtrosEstado);
            dispatch({
                type: SET_INFO_DASHBOARD_ACTIVOS,
                payload: {...resp.data}
            });
            return resp.data;
        } catch (error) {
            console.log("error en getInfoActivosDashboard");
            console.log(error);
            
        }
    }

    const iniciarFiltros = () => {
        dispatch({
            type: SET_FILTERS,
            payload: initialState.filtros
        });
    }

    const setFiltros = (filtros) => {
        dispatch({
            type: SET_FILTERS,
            payload: filtros
        })
    }

    const filterActivos = () => {
        let activosFiltrados = activoListRef.current;
        // Tablero Activos: ocultar siempre los activos dados de baja. Soft-delete: siguen visibles solo en TreeActivo/FormActivo para reactivarlos.
        activosFiltrados = activosFiltrados.filter(a => !a.deBaja);
        let filtros = state.filtros;

        //Recorro las 3 keys de filtros, areas, nivel2s y nivel3s.
        Object.keys(filtros).forEach(key => {
            switch(key){
                case 'areas':
                    //Si alguna de ellas tiene algun valor seteado como filtro, filtro por esa condicion, sino se omite.
                    activosFiltrados = filtros[key].length > 0 ? activosFiltrados.filter(a => filtros[key].map(a => a.value).includes(a.activoNivel1ID)) : activosFiltrados;
                    break;
                case 'nivel2s':
                    activosFiltrados = filtros[key].length > 0 ? activosFiltrados.filter(a => filtros[key].map(a => a.value).includes(a.activoNivel2ID)) : activosFiltrados;
                    break;
                case 'nivel3s':
                    activosFiltrados = filtros[key].length > 0 ? activosFiltrados.filter(a => filtros[key].map(a => a.value).includes(a.activoNivel3ID)) : activosFiltrados;
                    break;
                case 'nivel4s':
                    activosFiltrados = filtros[key].length > 0 ? activosFiltrados.filter(a => filtros[key].map(a => a.value).includes(a.activoNivel4ID)) : activosFiltrados;
                    break;
                case 'nivel5s':
                    activosFiltrados = filtros[key].length > 0 ? activosFiltrados.filter(a => filtros[key].map(a => a.value).includes(a.activoNivel5ID)) : activosFiltrados;
                    break;
                case 'state':
                    activosFiltrados = filtros[key].length > 0 ? activosFiltrados.filter(a => filtros[key].includes(a.actStatus)) : activosFiltrados;
                    break;
                case 'criticidad':
                    let filtrosMapped = filtros[key].map(f => f == 'BAJA' ? '0' : f == 'MEDIA' ? '1' : '2');
                    activosFiltrados = filtros[key].length > 0 ? activosFiltrados.filter(a => filtrosMapped.includes(a.criticidad)) : activosFiltrados;
                    break;
                case 'uniMeds':
                    activosFiltrados = filtros[key].length > 0 ? activosFiltrados.filter(a => filtros[key].includes(a.DEFAULTUNIMED.value)) : activosFiltrados;
                    break;

            }
        })
        return activosFiltrados;
    }

    //Inicializa los filtros dependiendo del usuarios 
    const iniciarFiltrosProcsProgramados = async (usuarioParam = "", tipoAlerta = ALERTSProcedimientosProgramados, tipoProcedimientos = TIPPROCS, statesProcedimientosParam = STATESProcsProgramados, origenesParam = ORIGENES, filtrosRango = initialState.filtrosProcsProgramadosRango) => {
        try {
            //Paso todos los dates de los filtros rango a un valor valido ademas de transfor en cadena de string para pasar en peticion get.
            const filtrosString = filtrosToString(filtrosRango);

            let userToUse = usuarioParam ? usuarioParam : usuario;

            //Obtengo los usuarios que puede ver el userToUse mediante su campo groupV
            const respUsuarios = await getUsersInGroupV(userToUse._id);
            
            //Creo un arreglo de userNames y luego si no se encuentra el userToUse en sesion lo agrego
            const usuarios = [...new Set(respUsuarios.data.data.map((u) => u.user.userName))];

            if(!usuarios.includes(userToUse.userName)) usuarios.push(userToUse.userName);

            const tipoAlertaToUse = (wSpaceFromActivos && wSpaceFromActivos == 'porVencer') ? ['PorVENC'] : (wSpaceFromActivos && wSpaceFromActivos == 'vencidos') ? ['VENC'] : tipoAlerta;
            const estadosToUse = (wSpaceFromActivos && origenFromActivos) ? ['PEND', 'PROG'] : statesProcedimientosParam;

            const filtrosEstado = { ...initialState.filtrosProcsProgramadosEstado, tipoAlerta:  tipoAlertaToUse, tipoProcedimientos: tipoProcedimientos, statesProcedimientos: estadosToUse, origenes: origenFromActivos ? [origenFromActivos] : origenesParam, statesChecklist: CHECKLISTStates, userName: usuarios, tipoActivos: [], activos: userToUse.activosAllowed.map(a => a.value)};

            dispatch({
                type: INICIALIZAR_FILTROS,
                payload: {
                    filtrosEstado: filtrosEstado,
                    filtrosRango: filtrosRango
                }
            });

            let res = await getProcsProgramados(userToUse._id, `${filtrosString}&vistaProcsProgramados=1`);
            dispatch({
                type: ACTUALIZAR_PROCS_PROGRAMADOS,
                payload: res.data.procs
            });

            return true;
        } catch (error) {
            console.log(error);
            console.log("Error a la hora de iniciar filtros");
        }
    };

    //Modifica los filtros de rango y trae los tDocs acorde a los parametros enviados
    const modificarFiltrosRango = async (userId , filtrosRango) => {
        const filtrosString = filtrosToString(filtrosRango);

        let areEquals = deepEqual(state.filtrosProcsProgramadosRango, filtrosRango);

        //Si se detectaron cambios en los filtros por rango, vuelven a solicitarse los documentos al backend.
        if(!areEquals){
            dispatch({
                type: MODIFICAR_FILTROS_RANGO,
                payload: { filtrosRango }
            })

            let res = await getProcsProgramados(userId, `${filtrosString}&vistaProcsProgramados=1`);

            dispatch({
                type: ACTUALIZAR_PROCS_PROGRAMADOS,
                payload: res.data.procs
            });
        }
    };

    //Modifica los filtros de estado
    const modificarFiltrosEstado = (filtrosEstados) => {
        setWSpaceFromActivos(null);
        setOrigenFromActivos(null);

        dispatch({
            type: MODIFICAR_FILTROS_ESTADOS,
            payload: {...filtrosEstados}
        })
    };

    const reinitilizeFiltrosEstado = () => {
        wSpaceFromActivos && setWSpaceFromActivos(null);
        origenFromActivos && setOrigenFromActivos(null);

        const activosAllowed = usuario?.activosAllowed?.map(a => a.value) ?? [];
        dispatch({
            type: MODIFICAR_FILTROS_ESTADOS,
            payload: {...initialState.filtrosProcsProgramadosEstado, origenes: ORIGENES, activos: activosAllowed}
        })
    }

    const filtrarProcsProgramados = (lista, filtrosEstado, filtrosRango = {}) => {
        try {
            let listaFiltrada;

            if (!lista || lista === undefined) return undefined;

            listaFiltrada = lista.slice();        

            let fecVec = '';
            let fecCom = '';
            let fecVecProcedimiento;
            let fecComProcedimiento;
                
            const truncateTime = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

            if(filtrosRango.fecVencimientoHasta != undefined){
                fecVec = new Date(filtrosRango.fecVencimientoHasta);
                fecVec = truncateTime(fecVec);
            }
            if(filtrosRango.fecCompletadoHasta != undefined){
                fecCom = new Date(filtrosRango.fecCompletadoHasta);
                fecCom = truncateTime(fecCom);
            }

            listaFiltrada = listaFiltrada.filter((p) => {
                fecVecProcedimiento = new Date((p.fechaVencimiento != '') ? p.fechaVencimiento : '1900-01-01');
                fecVecProcedimiento = truncateTime(fecVecProcedimiento);
                fecComProcedimiento = new Date((p.fechaCompletado != '') ? p.fechaCompletado : '1900-01-01');
                fecComProcedimiento = truncateTime(fecComProcedimiento);

                return (fecVecProcedimiento <= fecVec && fecComProcedimiento <= fecCom && filtrosEstado.tipoAlerta.includes(p.tipoAlerta) && (filtrosEstado.activos.length == 0 || filtrosEstado.activos.includes(p.codActivo)) && filtrosEstado.origenes.includes(p.originado) && filtrosEstado.tipoProcedimientos.includes(p.tipProc.value) && filtrosEstado.statesProcedimientos.includes(p.state) && (filtrosEstado.tipoActivos.length == 0 || p.tipAct.some(tA => filtrosEstado.tipoActivos.includes(tA))));
            })

            return listaFiltrada;
        } catch (error) {
            console.log("error en filtrarChecklistRegistrados");
            console.log(error);
            return [];
        }
    }

    const moveToTopAct = async(id) => {
        let activoList = activoListRef.current.map(a => ({...a}));
        
        let activosToUpdatePosition = [];

        let activoToMoveUp = activoList.find(a => a._id == id);

        if(activoToMoveUp.activoNivel5ID){
            let activosLv5 = activoList.filter(a => a.activoNivel5ID == activoToMoveUp.activoNivel5ID);
            let index = activosLv5.findIndex(a => a._id == id);
            if(index == 0) return;
            else{            
                activosLv5 = activosLv5.map(a => ({...a, position: a.position + 1}));
                activosLv5[index].position = 1;

                for(const act of activosLv5){
                    activosToUpdatePosition.push({_id:act._id, position: act.position});
                }

                activoList = activoList.map((a,i) => {
                        let finded = activosLv5.find(act => act._id == a._id);
                        if(finded) return {...finded}
                        else return {...a};
                });

                activoList = activoList.sort((a,b) => a.position - b.position);
                activoListRef.current = activoList;
            }
        }else if(activoToMoveUp.activoNivel4ID){
            let activosLv4 = activoList.filter(a => a.activoNivel4ID == activoToMoveUp.activoNivel4ID && !a.activoNivel5ID);
            let index = activosLv4.findIndex(a => a._id == id);
            if(index == 0) return;
            else{
                activosLv4 = activosLv4.map(a => ({...a, position: a.position + 1}));
                activosLv4[index].position = 1;

                for(const act of activosLv4){
                    activosToUpdatePosition.push({_id:act._id, position: act.position});
                }

                activoList = activoList.map((a,i) => {
                        let finded = activosLv4.find(act => act._id == a._id);
                        if(finded) return {...finded}
                        else return {...a};
                });

                activoList = activoList.sort((a,b) => a.position - b.position);
                activoListRef.current = activoList;
            }
        }else if(activoToMoveUp.activoNivel3ID){
            let activosLv3 = activoList.filter(a => a.activoNivel3ID == activoToMoveUp.activoNivel3ID && !a.activoNivel4ID && !a.activoNivel5ID);
            let index = activosLv3.findIndex(a => a._id == id);
            if(index == 0) return;
            else{
                activosLv3 = activosLv3.map(a => ({...a, position: a.position + 1}));
                activosLv3[index].position = 1;

                for(const act of activosLv3){
                    activosToUpdatePosition.push({_id:act._id, position: act.position});
                }

                activoList = activoList.map((a,i) => {
                        let finded = activosLv3.find(act => act._id == a._id);
                        if(finded) return {...finded}
                        else return {...a};
                });

                activoList = activoList.sort((a,b) => a.position - b.position);
                
                activoListRef.current = activoList;
            }
        }else if(activoToMoveUp.activoNivel2ID){
            let activosLv2 = activoList.filter(a => a.activoNivel2ID == activoToMoveUp.activoNivel2ID && !a.activoNivel3ID &&  !a.activoNivel4ID && !a.activoNivel5ID);
            let index = activosLv2.findIndex(a => a._id == id);
            if(index == 0) return;
            else{
                activosLv2 = activosLv2.map(a => ({...a, position: a.position + 1}));
                activosLv2[index].position = 1;

                for(const act of activosLv2){
                    activosToUpdatePosition.push({_id:act._id, position: act.position});
                }

                activoList = activoList.map((a,i) => {
                        let finded = activosLv2.find(act => act._id == a._id);
                        if(finded) return {...finded}
                        else return {...a};
                });

                activoList = activoList.sort((a,b) => a.position - b.position);
                activoListRef.current = activoList;
            }
        }else{
            let activosLv1 = activoList.filter(a => a.activoNivel1ID == activoToMoveUp.activoNivel1ID && !a.activoNivel2ID && !a.activoNivel3ID &&  !a.activoNivel4ID && !a.activoNivel5ID);
            let index = activosLv1.findIndex(a => a._id == id);
            if(index == 0) return;
            else{
                activosLv1 = activosLv1.map(a => ({...a, position: a.position + 1}));
                activosLv1[index].position = 1;

                for(const act of activosLv1){
                    activosToUpdatePosition.push({_id:act._id, position: act.position});
                }

                activoList = activoList.map((a,i) => {
                        let finded = activosLv1.find(act => act._id == a._id);
                        if(finded) return {...finded}
                        else return {...a};
                });

                activoList = activoList.sort((a,b) => a.position - b.position);
                activoListRef.current = activoList;
            }
        }

        await updatePositioning(activosToUpdatePosition);
        dispatch({
            type: ACTUALIZAR_LIST_ACTIVO,
            payload: activoList
        });
    }
    
    const moveToBottomAct = async (id) => {
        let activoList = activoListRef.current.map(a => ({...a}));
        let activosToUpdatePosition = [];
        let activoToMoveUp = activoList.find(a => a._id == id);

        if(activoToMoveUp.activoNivel5ID){
            let activosLv5 = activoList.filter(a => (a.activoNivel5ID == activoToMoveUp.activoNivel5ID && a.position >= activoToMoveUp.position));
            
            let index = activosLv5.findIndex(a => a._id == id);
            if(index == activosLv5.length - 1) return;
            else{            
                activosLv5 = activosLv5.map(a => ({...a, position: a.position + 1}));
                activosLv5[index].position = 1;

                for(const act of activosLv5){
                    activosToUpdatePosition.push({_id:act._id, position: act.position});
                }

                activoList = activoList.map((a,i) => {
                        let finded = activosLv5.find(act => act._id == a._id);
                        if(finded) return {...finded}
                        else return {...a};
                });

                activoList = activoList.sort((a,b) => a.position - b.position);
                activoListRef.current = activoList;
            }
        }else if(activoToMoveUp.activoNivel4ID){
            let activosLv4 = activoList.filter(a => a.activoNivel4ID == activoToMoveUp.activoNivel4ID && !a.activoNivel5ID);
            let index = activosLv4.findIndex(a => a._id == id);
            if(index == activosLv4.length - 1) return;
            else{
                activosLv4 = activosLv4.map(a => ({...a, position: a.position + 1}));
                activosLv4[index].position = 1;

                for(const act of activosLv4){
                    activosToUpdatePosition.push({_id:act._id, position: act.position});
                }

                activoList = activoList.map((a,i) => {
                        let finded = activosLv4.find(act => act._id == a._id);
                        if(finded) return {...finded}
                        else return {...a};
                });

                activoList = activoList.sort((a,b) => a.position - b.position);
                activoListRef.current = activoList;
            }
        }else if(activoToMoveUp.activoNivel3ID){
            let activosLv3 = activoList.filter(a => (a.activoNivel3ID == activoToMoveUp.activoNivel3ID && !a.activoNivel4ID && !a.activoNivel5ID && a.position >= activoToMoveUp.position));

            let index = activosLv3.findIndex(a => a._id == id);

            if(index == activosLv3.length - 1) return;
            else{
                activosLv3 = activosLv3.map(a => ({...a, position: a.position - 1}));
                activosLv3[index].position = activosLv3[activosLv3.length-1].position + 1;

                for(const act of activosLv3){
                    activosToUpdatePosition.push({_id:act._id, position: act.position});
                }

                activoList = activoList.map((a,i) => {
                        let finded = activosLv3.find(act => act._id == a._id);
                        if(finded) return {...finded}
                        else return {...a};
                });

                activoList = activoList.sort((a,b) => a.position - b.position);
                
                activoListRef.current = activoList;
            }
        }else if(activoToMoveUp.activoNivel2ID){
            let activosLv2 = activoList.filter(a => a.activoNivel2ID == activoToMoveUp.activoNivel2ID && !a.activoNivel3ID &&  !a.activoNivel4ID && !a.activoNivel5ID);
            let index = activosLv2.findIndex(a => a._id == id);
            if(index == activosLv2.length - 1) return;
            else{
                activosLv2 = activosLv2.map(a => ({...a, position: a.position + 1}));
                activosLv2[index].position = 1;

                for(const act of activosLv2){
                    activosToUpdatePosition.push({_id:act._id, position: act.position});
                }

                activoList = activoList.map((a,i) => {
                        let finded = activosLv2.find(act => act._id == a._id);
                        if(finded) return {...finded}
                        else return {...a};
                });

                activoList = activoList.sort((a,b) => a.position - b.position);
                activoListRef.current = activoList;
            }
        }else{
            let activosLv1 = activoList.filter(a => a.activoNivel1ID == activoToMoveUp.activoNivel1ID && !a.activoNivel2ID && !a.activoNivel3ID &&  !a.activoNivel4ID && !a.activoNivel5ID);
            let index = activosLv1.findIndex(a => a._id == id);
            if(index == activosLv1.length - 1) return;
            else{
                activosLv1 = activosLv1.map(a => ({...a, position: a.position + 1}));
                activosLv1[index].position = 1;

                for(const act of activosLv1){
                    activosToUpdatePosition.push({_id:act._id, position: act.position});
                }

                activoList = activoList.map((a,i) => {
                        let finded = activosLv1.find(act => act._id == a._id);
                        if(finded) return {...finded}
                        else return {...a};
                });

                activoList = activoList.sort((a,b) => a.position - b.position);
                activoListRef.current = activoList;
            }
        }

        await updatePositioning(activosToUpdatePosition);
        dispatch({
            type: ACTUALIZAR_LIST_ACTIVO,
            payload: activoList
        });
    }

    // const updatePositionActivo = async (id, position) => {
    //     let activosUpdated = activoListRef.current;
    //     activosUpdated = activosUpdated.map(a => ({
    //         ...a,
    //         position: a._id == id ? position : a.position
    //     }));
    //     activoListRef.current = activosUpdated;
    //     await updatePositioning([{_id: id, position}]);
    //     dispatch({
    //         type: ACTUALIZAR_LIST_ACTIVO,
    //         payload: activosUpdated
    //     });
    // }
    const updatePositionActivo = async (updates) => {
        let activosUpdated = activoListRef.current;
        activosUpdated = activosUpdated.map(a => {
            let actFound = updates.find(upd => upd._id == a._id);
            return {
                ...a,
                position: actFound ? actFound.position : a.position
            }
        });
        activoListRef.current = activosUpdated;
        await updatePositioning(updates);
        dispatch({
            type: ACTUALIZAR_LIST_ACTIVO,
            payload: activosUpdated
        });
    }

    useEffect(() => {
        userRef.current = usuario;
        if(usuario != null){
            actualizaractivoList();
            iniciarFiltrosProcsProgramados();
        }
    },[usuario])

    useEffect(() => {
        if(server){
            server.on('newActivo', ({activoCreated,tenantId}) =>{
                console.log("Recibo el evento del Real Time Server newActivo");
                const update = verificarTenant(tenantId);
                if(update && usuario.activosAllowed.length == 0){
                    if(Array.isArray(activoListRef.current) && activoListRef.current.length > 0 && activoCreated != undefined){
                        let activoList = activoListRef.current.slice();
                        activoList.push(activoCreated); //Reveer logica aca al crear nuevo activo y decidir si este debe añadirse a la lista de activos filtrados del usuario que lo esta creando o no
                        activoListRef.current = activoList;
                        dispatch({
                            type: ACTUALIZAR_LIST_ACTIVO,
                            payload: activoList
                        });
                    }
                }
            })
            
            server.on('activoUpdated', ({updated,tenantId}) =>{
                console.log("Recibo el evento del Real Time Server activoUpdated");
                let update = verificarTenant(tenantId);
                if(update){
                    if(Array.isArray(activoListRef.current) && activoListRef.current.length > 0 && updated != undefined){
                        let activoList = activoListRef.current.slice();

                        activoList.forEach((a,i) => {
                            if(a.codActivo == updated.codActivo) activoList[i] = updated;
                        })
                        
                        activoListRef.current = activoList;
                        dispatch({
                            type: ACTUALIZAR_LIST_ACTIVO,
                            payload: activoList
                        });
                    }
                }
            })
            
            server.on('activoDeleted', ({id,tenantId}) =>{
                console.log("Recibo el evento del Real Time Server activoDeleted");
                let update = verificarTenant(tenantId);
                
                if(update){
                    if(Array.isArray(activoListRef.current) && activoListRef.current.length > 0 && id != undefined){
                        let activoList = activoListRef.current.slice();

                        activoList = activoList.filter(a => a._id != id);

                        activoListRef.current = activoList;
                        dispatch({
                            type: ACTUALIZAR_LIST_ACTIVO,
                            payload: activoList
                        });
                    }
                }
            })

            server.on('procsCalculados', ({tenantId}) => {
                console.log("Recibo el evento del Real Time Server procsCalculados");
                let update = verificarTenant(tenantId);
                if(update) getMantenimientosProgramados();
            });

            server.on('lecturasUpdated', ({updated,tenantId}) => {
                console.log("Recibo el evento del Real Time Server lecturasUpdated");
                let flag = false;
                let update = verificarTenant(tenantId);
                if(update){
                    if(Array.isArray(activoListRef.current) && activoListRef.current.length > 0 && updated != undefined){
                        let activoList = activoListRef.current.slice();
                        
                        activoList.forEach((a,i) => {
                            if(updated.length > 0){
                                updated.forEach((actToUpdate, index) => {
                                    if(a._id == actToUpdate.activoID && a.DEFAULTUNIMED.value == actToUpdate.uniMed){
                                        activoList[i].lastLectura = actToUpdate.valor;
                                        flag = true;
                                        updated.splice(index,1);
                                        return;
                                    } 
                                })
                            } else return; //A medida que cada activo a updatear coincide, este se elimina del arreglo, cuando el tamaño de este arreglo a actualizar es 0 se finaliza el loop a traves de activoList.
                        })
                        activoListRef.current = activoList;
                        if(flag) dispatch({
                            type: ACTUALIZAR_LIST_ACTIVO,
                            payload: activoList
                        });
                    }
                }
            });

            return () => {
                server.off('newActivo');
                server.off('activoUpdated');
                server.off('procsCalculados');
                server.off('workingNowUpdated');
            }
        }
    }, [server, usuario]);
    
    return(
        <activoContext.Provider
            value={{
                activoList: state.activoList,
                initialState: initialState,
                infoActivosDashboard: state.infoActivosDashboard,
                procsProgramadosList: state.procsProgramadosList,
                docsXactivoList: state.docsXactivoList,
                filtros: state.filtros,
                cargandoActivos: state.cargandoActivos,
                cargandoProcsProgramados: state.cargandoProcsProgramados,
                filtrosProcsInicializados: state.filtrosProcsInicializados,
                filtrosProcsProgramadosEstado: state.filtrosProcsProgramadosEstado,
                filtrosProcsProgramadosRango: state.filtrosProcsProgramadosRango,
                actualizaractivoList,
                obtenerActivosAsOptions,
                modificarUserTrabajandoActivo,
                getActivoByCodActivo,
                agregarActivo,
                modificarActivo,
                eliminarActivo,
                toggleDeBajaActivo: toggleDeBajaActivoCtx,
                getFilesActivo,
                getDocFilesActivo,
                getFServFilesActivo,
                calcularMantenimientos,
                calcularMantenimientoByActivo,
                getMantenimientosProgramados,
                getDocsXActivo,
                getLastLecturaByUnidadAndActivo,
                addLectura,
                updateUserWorking,
                actualizarFServ,
                checkIfActivoHasODTForBreaking,
                addProcedimientoProgramado,
                actualizarProcProgramado,
                addProcedimientoDirecto,
                actualizarFecVencimientoDoc,
                getLectsByActivoId,
                actualizarUbicacionActivo,
                iniciarFiltros,
                iniciarFiltrosProcsProgramados,
                filterActivos,
                setFiltros,
                modificarFiltrosRango,
                modificarFiltrosEstado,
                filtrarProcsProgramados,
                getInfoActivosReporte,
                getControlServiciosReporte,
                getConsumoHorasMensualReporte,
                guardarCambioHorometro,
                getInfoActivosDashboard,
                reinitilizeFiltrosEstado,
                moveToTopAct,
                moveToBottomAct,
                updatePositionActivo
            }}
        >
            {props.children}
        </activoContext.Provider>
    )

}
export default ActivoState;

/* 
    Agrega archivos a un requerimiento.
        Donde req es el requerimiento.
              files son los archivos.
*/
const agregarArchivos = async (act, campo, files) => {
    try {
        const formData = new FormData();
        files.map((f, i) => {
            formData.append(`files`, f.dato);
        });
        formData.append('prefijo', `${act.codActivo}-${campo}`);
        await addFiles(formData);//clienteAxios.post('/transactionDocument/file', formData, {headers: {'Content-Type': 'multipart/form-data'}, timeout: 0});
        return true;
    } catch (error) {
        console.log("Error en agregar archivos");
        console.log(error);
        throw new Error(`Error al guardar archivos del requerimiento ${act.codActivo + "-" + campo}`)
    }
}

//Variante que retorna la respuesta completa (con keys S3) para el flujo de disponibilidad.
//Envia fecMod + codActivo para que el backend valide concurrencia antes de tocar S3.
const agregarArchivosConKey = async (act, campo, files) => {
    const formData = new FormData();
    files.map((f) => formData.append('files', f.dato));
    formData.append('prefijo', `${act.codActivo}-${campo}`);
    formData.append('codActivo', act.codActivo);
    if(act.fecMod) formData.append('fecMod', act.fecMod);
    const resp = await addFiles(formData);
    return resp?.data;
}




